import { StandardsModal } from "./StandardsModal.component";

export { StandardsModal };
